/**
 * ChartType
 * @author ftgibran
 */
export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
}
